import React from "react";
import { Formik, FormikProps } from "formik";
import * as Yup from "yup";
import { wire } from "react-hot-wire";

import { SiteService } from "services/site/Site.service";

import { Application } from "models/application/Application";

import Drawer from "components/common/drawer/Drawer";

import AddUser from "./AddUser.template";

export type AddUserFormValues = {
  email: string;
  forename: string;
  surname: string;
};

const AddUserSchema = Yup.object().shape({
  email: Yup.string()
    .email()
    .required(),
  forename: Yup.string().required(),
  surname: Yup.string().required()
});

function AddUserComponent({
  application,
  siteService,
  drawerProps,
  action
}: {
  application: Application;
  siteService: SiteService;
  drawerProps?: any;
  action?: () => void;
}) {
  return (
    <Drawer
      {...drawerProps}
      render={({ close }: { close: () => void }) => (
        <Formik
          initialValues={{
            email: "",
            forename: "",
            surname: ""
          }}
          validationSchema={AddUserSchema}
          onSubmit={(values: AddUserFormValues) =>
            siteService
              .addUser({
                values,
                application
              })
              .then(close)
              .then(action)
          }
          render={(props: FormikProps<AddUserFormValues>) => (
            <AddUser formikProps={props} close={close} />
          )}
        />
      )}
    />
  );
}

export default wire(["siteService"], AddUserComponent);
